import Vue from 'vue'
import VueRouter from 'vue-router'
import defaultLayout from '@/layouts/defaultLayout.vue'
import blankLayout from '@/layouts/blankLayout.vue'

// 注册路由插件
Vue.use(VueRouter)

// 定义路由
const routes = [
	{
		path: '/',
		component: defaultLayout,
		children: [
			{ path: '', component: () => import('@/views/check-major.vue') },
			{ path: 'check-job', component: () => import('@/views/check-job.vue'), meta: { keepAlive: true } },
			{ path: 'major-compare', component: () => import('@/views/major-compare.vue') },
			{ path: 'central', component: () => import('@/views/central.vue') },
			{ path: 'qualification', component: () => import('@/views/qualification.vue') },
			{ path: 'consulting', component: () => import('@/views/consulting.vue'), meta: { keepAlive: true } },
			{ path: 'article', component: () => import('@/views/article.vue') },
			{ path: 'student', component: () => import('@/views/student.vue'), meta: { keepAlive: true } },
			{ path: 'add-student', component: () => import('@/views/addStudent.vue') },
			{ path: 'fraction', component: () => import('@/views/fraction.vue') },
			{ path: 'unit', component: () => import('@/views/unit.vue') },
			{ path: 'targeted', component: () => import('@/views/targeted.vue') },
			{ path: 'ordinary', component: () => import('@/views/ordinary.vue') },
			{ path: 'basicReport', component: () => import('@/views/basicReport.vue') },
			{ path: 'report', component: () => import('@/views/report.vue') },
			{ path: 'my-order', component: () => import('@/views/my-order.vue') },
			{ path: 'friend', component: () => import('@/views/friend.vue'), meta: { keepAlive: true } },
			{ path: 'friendContent', component: () => import('@/views/friendContent.vue') },
			{ path: 'edit-info', component: () => import('@/views/edit-info.vue') },
			{ path: 'edit-password', component: () => import('@/views/edit-password.vue') }
		]
	},
	{  // 分享H5页面
		path: '/friendContentH5',
		component: blankLayout,
		children: [
			{ path: '', component: () => import('@/views/friendContentH5.vue') }
		]
	},
	{  // 404页面
		path: '/no-found',
		component: blankLayout,
		children: [
			{ path: '', component: () => import('@/views/no-found.vue') }
		]
	}
]

// 创建路由实例
const router = new VueRouter({
  mode: 'hash',       // 使用history模式去掉URL中的#
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
      // 始终滚动到顶部
      return { x: 0, y: 0 }
      // 或者如果有保存的位置则返回保存的位置
      // if (savedPosition) {
      //   return savedPosition
      // } else {
      //   return { x: 0, y: 0 }
      // }
  }
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
	if (to.path === from.path && to.name === from.name) return
	
	const app = document.getElementById('app')
    
    if (from.meta.pageClass) {
      app.classList.remove(from.meta.pageClass)
    }
    
    if (to.meta.pageClass) {
      app.classList.add(to.meta.pageClass)
    }
    
    next()
})

export default router